import React, { useState, useEffect } from "react";
import { Checkbox, Grid, Icon, Image, Menu, Popup } from "semantic-ui-react";
import filter from "lodash/filter";
import isUndefined from "lodash/isUndefined";
import PlayIcon from "../../assets/icons/player/play.svg";
import StopIcon from "../../assets/icons/player/stop.svg";
import { Event } from "../../services/Event";

const AutoplayerButton = ({
    variations,
    variation,
    soundplayer,
    bus,
    playTrackerActive,
    playTrackerChanged,
}) => {
    const [playbackIsOn, setPlaybackIsOn] = useState(false);
    const [withDesignatedInstrument, setWithDesignatedInstrument] =
        useState(true);

    useEffect(() => {
        const stop = bus.take(Event.PlaybackFinished, () => {
            // stopPlayback(); // FIXME disabled temporarily
        });

        return () => {
            stop();
        };
    }, [bus]);

    useEffect(() => {
        //if variation changes, stop autoplayer
        if (playbackIsOn) {
            stopPlayback();
            setPlaybackIsOn(false);
        }
        setWithDesignatedInstrument(true);
    }, [variation.id]);

    const designatedInstrumentCheckboxChanged = (e, data) => {
        setWithDesignatedInstrument(data.checked);
    };

    const togglePlayTracker = (event, data) => {
        playTrackerChanged(playTrackerActive);
    };

    const startPlayback = (variationsToPlay, withDesignatedInstrument) => {
        setPlaybackIsOn(true);
        soundplayer.startPlayback(variationsToPlay, withDesignatedInstrument);
    };

    const stopPlayback = () => {
        setPlaybackIsOn(false);
        soundplayer.stopPlayback();
    };

    const showVariationAutoplayPopup = (variations, selectedVariation) => {
        const variationsWithoutClip = filter(variations, (item) => {
            return item.type.value !== "CLIP";
        });
        const showAccompaniments = variationsWithoutClip.length > 2;
        const accompaniments = filter(variationsWithoutClip, (item) => {
            return item.id !== selectedVariation.id;
        });
        return (
            <Popup
                style={{
                    height:
                        35 * variations.length +
                        (showAccompaniments ? 105 : 85),
                }}
                trigger={
                    <Menu.Item>
                        <Icon size="big">
                            {" "}
                            <Image centered src={PlayIcon} />{" "}
                        </Icon>
                        <span className="mobile-hide mtudeIconButton iconFont">
                            Play
                        </span>
                    </Menu.Item>
                }
                on="click"
                position="bottom left"
            >
                {variationsWithoutClip.length > 1 ? (
                    <Grid.Row>
                        <Grid.Column>
                            <span
                                className="mtudeIconButton"
                                onClick={() =>
                                    startPlayback(
                                        variationsWithoutClip,
                                        withDesignatedInstrument
                                    )
                                }
                            >
                                <Icon size="large">
                                    {" "}
                                    <Image centered src={PlayIcon} />{" "}
                                </Icon>{" "}
                                Play All
                            </span>
                        </Grid.Column>
                    </Grid.Row>
                ) : (
                    ""
                )}

                {variations.map((variation, index) => {
                    return (
                        <Grid.Row key={index}>
                            <Grid.Column>
                                <span
                                    className="mtudeIconButton"
                                    onClick={() =>
                                        startPlayback(
                                            [variations[index]],
                                            withDesignatedInstrument
                                        )
                                    }
                                >
                                    <Icon size="large">
                                        {" "}
                                        <Image centered src={PlayIcon} />{" "}
                                    </Icon>{" "}
                                    {variation.type.displayValue}
                                </span>
                            </Grid.Column>
                        </Grid.Row>
                    );
                })}
                {showAccompaniments ? (
                    <Grid.Row>
                        <Grid.Column>
                            <span
                                className="mtudeIconButton"
                                onClick={() =>
                                    startPlayback(
                                        accompaniments,
                                        withDesignatedInstrument
                                    )
                                }
                            >
                                <Icon size="large">
                                    {" "}
                                    <Image centered src={PlayIcon} />{" "}
                                </Icon>{" "}
                                Play Accompaniments
                            </span>
                        </Grid.Column>
                    </Grid.Row>
                ) : (
                    ""
                )}
                <br />
                <Grid.Row>
                    <Grid.Column>
                        <Checkbox
                            onChange={togglePlayTracker}
                            checked={playTrackerActive}
                            label="Tracker on/off"
                        />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <Checkbox
                            onChange={designatedInstrumentCheckboxChanged}
                            checked={withDesignatedInstrument}
                            label="Use designated instruments"
                        />
                    </Grid.Column>
                </Grid.Row>
            </Popup>
        );
    };

    if (isUndefined(variation)) {
        return <div />;
    }

    return (
        <div>
            {playbackIsOn ? (
                <Menu.Item onClick={stopPlayback}>
                    <Icon size="big">
                        {" "}
                        <Image centered src={StopIcon} />{" "}
                    </Icon>
                    <span className="mobile-hide mtudeIconButton iconFont">
                        Stop
                    </span>
                </Menu.Item>
            ) : variations.length > 1 ? (
                showVariationAutoplayPopup(variations, variation)
            ) : (
                <Menu.Item onClick={() => startPlayback(variations, false)}>
                    <Icon size="big">
                        {" "}
                        <Image centered src={PlayIcon} />{" "}
                    </Icon>
                    <span className="mobile-hide mtudeIconButton iconFont">
                        Play
                    </span>
                </Menu.Item>
            )}
        </div>
    );
};

export default AutoplayerButton;
